import { __assign, __extends } from "tslib";
import Annotation from './base';
var Image = /** @class */ (function (_super) {
    __extends(Image, _super);
    function Image(cfg) {
        /* istanbul ignore next */
        return _super.call(this, __assign({ type: 'image', start: null, end: null, src: '' }, cfg)) || this;
    }
    Image.prototype.render = function (coord, group) {
        var start = this.parsePoint(coord, this.get('start'));
        var cfg = {
            x: start.x,
            y: start.y,
            img: this.get('src'),
        };
        if (!this.get('end')) {
            cfg.width = this.get('width') || 32;
            cfg.height = this.get('height') || 32;
        }
        else {
            var end = this.parsePoint(coord, this.get('end'));
            cfg.width = end.x - start.x;
            cfg.height = end.y - start.y;
        }
        if (this.get('offsetX')) {
            cfg.x += this.get('offsetX');
        }
        if (this.get('offsetY')) {
            cfg.y += this.get('offsetY');
        }
        var imgGuide = group.addShape('Image', {
            zIndex: 1,
            attrs: cfg,
        });
        imgGuide.name = 'annotation-image';
        this.get('appendInfo') &&
            imgGuide.setSilent('appendInfo', this.get('appendInfo'));
        this.set('el', imgGuide);
    };
    return Image;
}(Annotation));
export default Image;
//# sourceMappingURL=image.js.map